// Registro do service worker e inscrição em push.
//
// Tudo aqui falha em silêncio de propósito. O PWA é um extra: navegador sem
// suporte, permissão negada, modo privativo e service worker bloqueado por
// política são situações normais, e nenhuma delas pode quebrar a tela de quem
// só queria ver as intimações.

import axios from "axios";
import { API } from "../contexts/AuthContext";

export const temSuporte = () =>
  typeof navigator !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export async function registrarServiceWorker() {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return null;
  try {
    return await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  } catch (e) {
    return null;
  }
}

// A chave VAPID viaja como base64url e o PushManager exige Uint8Array.
function chaveParaBytes(base64url) {
  const preenchimento = "=".repeat((4 - (base64url.length % 4)) % 4);
  const base64 = (base64url + preenchimento).replace(/-/g, "+").replace(/_/g, "/");
  const bruto = window.atob(base64);
  const bytes = new Uint8Array(bruto.length);
  for (let i = 0; i < bruto.length; i += 1) bytes[i] = bruto.charCodeAt(i);
  return bytes;
}

export function permissaoAtual() {
  if (typeof Notification === "undefined") return "unsupported";
  return Notification.permission; // "default" | "granted" | "denied"
}

export async function jaInscrito() {
  if (!temSuporte()) return false;
  try {
    const registro = await navigator.serviceWorker.getRegistration();
    if (!registro) return false;
    return Boolean(await registro.pushManager.getSubscription());
  } catch (e) {
    return false;
  }
}

export async function inscrever() {
  if (!temSuporte()) throw new Error("Este navegador não suporta notificações.");

  const { data } = await axios.get(`${API}/push/chave`, { withCredentials: true });
  if (!data?.habilitado || !data?.chave) {
    throw new Error("As notificações ainda não estão disponíveis.");
  }

  const permissao = await Notification.requestPermission();
  if (permissao !== "granted") {
    // Negar é uma escolha legítima, e o navegador não deixa perguntar de novo:
    // dizer isso evita o usuário clicar no botão para sempre sem efeito.
    throw new Error(
      permissao === "denied"
        ? "As notificações foram bloqueadas para o TUTO. Libere nas configurações do navegador."
        : "Permissão não concedida.",
    );
  }

  const registro = (await navigator.serviceWorker.getRegistration())
    || (await registrarServiceWorker());
  if (!registro) throw new Error("Não foi possível preparar as notificações.");
  await navigator.serviceWorker.ready;

  const inscricao =
    (await registro.pushManager.getSubscription()) ||
    (await registro.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: chaveParaBytes(data.chave),
    }));

  const bruta = inscricao.toJSON();
  await axios.post(`${API}/push/inscrever`,
    { endpoint: bruta.endpoint, keys: bruta.keys },
    { withCredentials: true });
  return true;
}

export async function cancelar() {
  if (!temSuporte()) return false;
  const registro = await navigator.serviceWorker.getRegistration();
  const inscricao = registro && (await registro.pushManager.getSubscription());
  if (!inscricao) return false;
  const endpoint = inscricao.endpoint;
  await inscricao.unsubscribe();
  try {
    await axios.post(`${API}/push/cancelar`, { endpoint }, { withCredentials: true });
  } catch (e) {
    // O aparelho já cancelou localmente; o servidor limpa sozinho no primeiro
    // envio que receber 410.
  }
  return true;
}

export async function enviarTeste() {
  const { data } = await axios.post(`${API}/push/teste`, null, { withCredentials: true });
  return data;
}
